import { isNullish } from './Nullish';

/**
 * Return true if the input is null, undefined, or blank string
 */
export function isBlank(maybeString: string | undefined | null): boolean {
    return isNullish(maybeString) || maybeString === '';
}

/**
 * Return true if input is not null, undefined, or blank string
 */
export function isNotBlank(
    maybeString: string | undefined | null
): maybeString is NonNullable<string> {
    return !isBlank(maybeString);
}
